import React, { useEffect, useState } from 'react'
import { filtroEstadosOt } from '../../api/common'
import { Badge } from 'react-bootstrap'

const estadoVariants = {
  'Total':       { bg: '#2563eb', border: '#2563eb' },
  'Solicitud':   { bg: '#64748b', border: '#64748b' },
  'Programada':  { bg: '#0891b2', border: '#0891b2' },
  'Abierta':     { bg: '#16a34a', border: '#16a34a' },
  'Cerrada':     { bg: '#1e293b', border: '#1e293b' },
  'Cancelada':   { bg: '#ea580c', border: '#ea580c' },
  'Facturar':    { bg: '#d97706', border: '#d97706' },
  'Desactivada': { bg: '#dc2626', border: '#dc2626' },
}

const defaultVariant = { bg: '#64748b', border: '#64748b' }

export const FiltroestadosOt = ({ handleSetFilters }) => {
  const [datos, setDatos] = useState([])
  const [activo, setActivo] = useState('Total')

  const estadoFilter = (e) => {
    setActivo(e)
    handleSetFilters({
      target: {
        name: 'estado',
        value: e === 'Total' ? undefined : e,
      },
    })
  }

  useEffect(() => {
    async function consultar() {
      const resultado = await filtroEstadosOt()
      const total = resultado.data.data.reduce((acc, item) => acc + item.cantidad, 0)
      const dataConTotal = [...resultado.data.data, { _id: 'Total', cantidad: total }]
      setDatos(dataConTotal)
    }
    consultar()
  }, [])

  return (
    <div
      className="mb-3"
      style={{
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
        /* Oculta scrollbar visualmente pero mantiene funcionalidad */
        scrollbarWidth: 'none',         /* Firefox */
        msOverflowStyle: 'none',        /* IE/Edge */
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'nowrap',           /* ← nunca hace salto de línea */
          gap: '6px',
          padding: '2px 1px 6px',
          width: 'max-content',         /* ← el contenedor crece con los items */
          minWidth: '100%',
        }}
      >
        {datos.map((item, index) => {
          const variant = estadoVariants[item._id] || defaultVariant
          const isActive = activo === item._id

          return (
            <button
              key={index}
              onClick={() => estadoFilter(item._id)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                padding: '4px 10px 4px 8px',
                border: `1.5px solid ${isActive ? variant.border : '#e2e8f0'}`,
                borderRadius: '6px',
                background: isActive ? `${variant.bg}10` : '#fff',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                transition: 'all 0.15s ease',
                boxShadow: isActive ? `0 0 0 1px ${variant.border}33` : '0 1px 2px rgba(0,0,0,0.06)',
                outline: 'none',
                flexShrink: 0,          /* ← no se encoge jamás */
              }}
              onMouseEnter={e => {
                if (!isActive) e.currentTarget.style.borderColor = variant.border
              }}
              onMouseLeave={e => {
                if (!isActive) e.currentTarget.style.borderColor = '#e2e8f0'
              }}
            >
              <span
                style={{
                  fontSize: '0.68rem',
                  fontWeight: 700,
                  letterSpacing: '0.04em',
                  textTransform: 'uppercase',
                  color: isActive ? variant.bg : '#475569',
                  lineHeight: 1,
                }}
              >
                {item._id}
              </span>
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: '20px',
                  height: '18px',
                  padding: '0 5px',
                  borderRadius: '4px',
                  background: variant.bg,
                  color: '#fff',
                  fontSize: '0.65rem',
                  fontWeight: 700,
                  lineHeight: 1,
                }}
              >
                {item.cantidad}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}